export const Action = {
  MESSAGE: "message",
  REDIRECT: "redirect",
};
